/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { FlexContainer, theme } from "@nordcloud/gnui";

export const Result = styled(FlexContainer)`
  border-bottom: 1px solid ${theme.color.border.border01};
  padding: ${theme.spacing.spacing02} 0;
`;

export const ResultLabel = styled.div`
  font-size: ${theme.fontSizes.xs};
  color: ${theme.color.text.text02};
  width: 4.5rem;
`;
